import { defineComponent as _defineComponent } from 'vue'
import { useElementSize } from '@vueuse/core'
import { inject, ref, watch } from 'vue'
import { ModalInjectionKey } from './injection-key'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalFooter',
  setup(__props) {

const el = ref<HTMLDivElement>()
const { height } = useElementSize(el, undefined, { box: 'border-box' })

const { close, updateFooterHeight } = inject(ModalInjectionKey)!

watch(height, (val) => {
  updateFooterHeight(val)
})

return { __sfc: true,el, height, close, updateFooterHeight }
}

})